import React, { Fragment, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import countryInfo from '../assets/countries.json';
import Login from '../components/views/login/Login';
import { ResponseFailModal } from '../components/modal/Response';
import { headerAction } from '../stores/actions';
import * as api from '../api';

const LoginContainer = ({history, location}) => {
  const { t, i18n } = useTranslation();
  const [ isOpenApiErrorModal, setIsOpenApiErrorModal ] = useState(false);
  const [ apiErrorMessage, setApiErrorMessage ] = useState('');
  const [ apiErrorSubMessage, setApiErrorSubMessage ] = useState('');
  const [ countryNumber, setCountryNumber ] = useState('82');
  const [ phoneNumber, setPhoneNumber ] = useState('');
  const [ password, setPassword ] = useState('');
  const countryInfoList = Object.values(countryInfo);
  const language = localStorage.getItem('mf_admin_lang') || 'ko';
  const dispatch = useDispatch();

  const changeLanguage = useCallback((language) => {
    localStorage.setItem('mf_admin_lang', language);
    i18n.changeLanguage(language);
    // dispatch(configAction.setPageLanguage(language));
  }, [i18n]);

  const loginApi = async () => {
    try {
      const reqNum = countryNumber + Number.parseInt(phoneNumber);
      const res = await api.login({phoneNumber: reqNum, password});
      localStorage.setItem('api_key', res.data.api_key);
      dispatch(headerAction.setHeaderItem({
        name: res.data.name,
      }));
    } catch (error) {
      setApiErrorMessage(t('error_message.login'));
      if (!error.response) setApiErrorSubMessage(error.message);
      else setApiErrorSubMessage(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenApiErrorModal(true);
      throw error;
    }
  };

  return (
    <Fragment>
      <Login
        t={t}
        language={language}
        countryNumber={countryNumber}
        phoneNumber={phoneNumber}
        password={password}
        countryInfoList={countryInfoList}
        setCountryNumber={setCountryNumber}
        setPhoneNumber={setPhoneNumber}
        setPassword={setPassword}
        changeLanguage={changeLanguage}
        loginApi={loginApi}
        history={history}
        location={location}
      />
      <ResponseFailModal
        isOpen={isOpenApiErrorModal}
        toggle={() => setIsOpenApiErrorModal(!isOpenApiErrorModal)}
        message={apiErrorMessage}
        subMessage={apiErrorSubMessage}
      />
    </Fragment>
  );
}

export default LoginContainer;